import { fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { createContext, useContext, useEffect, useRef, useState } from "react";

import { isAnonymousUser, isDOLAuthenticated } from "./authHelpers";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [auth, setAuth] = useState(null);
	const currentSessionPromise = useRef(null);

	useEffect(() => {
		const checkAuth = async () => {
			currentSessionPromise.current = null;
			if (isAnonymousUser()) {
				setAuth("anonymous");
				return;
			}

			if (isDOLAuthenticated()) {
				setAuth("dol");
				return;
			}

			let sessionPromise;
			try {
				sessionPromise = fetchAuthSession();
				currentSessionPromise.current = sessionPromise;

				const session = await sessionPromise;
				// prevent race
				if (currentSessionPromise.current === sessionPromise) {
					setAuth(session.tokens?.accessToken ? "cognito" : null);
				}
			} catch (e) {
				if (currentSessionPromise.current === sessionPromise) {
					setAuth(null);
				}
			}
		};

		checkAuth();

		return Hub.listen("auth", checkAuth);
	}, []);

	return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (context === undefined) {
		throw new Error("useAuth must be used within an AuthProvider");
	}
	return context;
};
